<template lang="pug">
  footer.footer(:class="{'footer_theme_dark': isHome}")
    nav-grid
    .container
      .privacy-list.footer__privacy-list
        a.privacy-list__link(href="#") Пользовательское соглашение
        a.privacy-list__link(href="#") Соглашение на&nbsp;использование персональных данных
        a.privacy-list__link(href="#") Договор присоединения
        a.privacy-list__link(href="#") Политика&nbsp;конфиденциальности
</template>

<script>
import navGrid from './nav-grid.vue'

export default {
  name: 'Footer',
  components: {
    navGrid
  },
  data () {
    return {
      menu: [
        {
          title: 'Парковка в аэропортах',
          submenu: [
            {
              name: 'Внуково',
              link: '#'
            },
            {
              name: 'Шереметьево',
              link: '#'
            },
            {
              name: 'Аэропорт г. Сочи',
              link: '#'
            }
          ]
        },
        {
          title: 'Корпоративным клиентам',
          submenu: [
            {
              name: 'Тарифы',
              link: '#'
            },
            {
              name: 'Описание',
              link: '#'
            }
          ]
        },
        {
          title: 'Тарифы',
          submenu: [
            {
              name: '1',
              link: '#'
            },
            {
              name: '2',
              link: '#'
            },
            {
              name: '3',
              link: '#'
            }
          ]
        },
        {
          title: 'Часто задаваемые вопросы',
          submenu: [
            {
              name: 'Для корпоративных клиентов',
              link: '#'
            },
            {
              name: 'Для частных лиц',
              link: '#'
            }
          ]
        },
        {
          title: 'Правила использования сервиса',
          submenu: [
            {
              name: 'Паркинг',
              link: '#'
            },
            {
              name: 'КАСКО',
              link: '#'
            },
            {
              name: 'Аэропорты',
              link: '#'
            },
            {
              name: 'Бензин',
              link: '#'
            },
            {
              name: 'Зоны',
              link: '#'
            }
          ]
        },
        {
          title: 'Пресс-центр',
          submenu: [
            {
              name: 'Новости',
              link: '#'
            },
            {
              name: 'Пресса о Нас',
              link: '#'
            },
            {
              name: 'Блог',
              link: '#'
            },
            {
              name: 'Бренд BelkaCar',
              link: '#'
            },
            {
              name: 'Контакты для прессы ',
              link: '#'
            }
          ]
        },
        {
          title: 'О компании',
          submenu: [
            {
              name: 'История',
              link: '#'
            },
            {
              name: 'О компании',
              link: '#'
            },
            {
              name: 'Основатели',
              link: '#'
            }
          ]
        }
      ]
    }
  },
  computed: {
    isHome () {
      if (this.$route.name === 'HomePage') return true

      return false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue